export const getExperimentArm = (experiments, experimentName) => {
    return (experiments === null || experiments === void 0 ? void 0 : experiments[experimentName]) || 'C';
};
